import { KonamiState } from '../types/KonamiState'

export const state: KonamiState = {
  code: null,
  overlay: false
}
